<template>
  <b-modal id="editleswin" size="lg" title="Редактирование занятия" @ok="submitClick" ok-title="Сохранить" cancel-title="Отмена">
    <b-form-datepicker
      v-model="rec.day"
      locale="ru"
      class="mb-2"
      placeholder="Не выбрана дата"
      :label-no-date-selected="'Не выбрана дата'"
      :label-help="'Используйте клавиши курсора для навигации по датам'"
      :label-prev-year="'Предыдущий год'"
      :label-prev-month="'Предыдущий месяц'"
      :label-next-month="'Следующий месяц'"
      :label-next-year="'Следующий год'"
      :label-current-month="'Текущий месяц'"
      :label-today="'Сегодня'"
      :label-close="'Закрыть'"
    ></b-form-datepicker>
    <b-form-select v-model="rec.lesson.time" :options="times" class="mb-2"></b-form-select>
    <b-form-input v-model="rec.lesson.predm" placeholder="Предмет" class="mb-2"></b-form-input>
    <b-form-select v-model="rec.lesson.type" :options="types" class="mb-2"></b-form-select>
    <b-form-input v-model="rec.lesson.kab" placeholder="Кабинет" class="mb-2"></b-form-input>
    <b-form-input v-model="rec.lesson.groups" placeholder="Группа" class="mb-2"></b-form-input>
  </b-modal>
</template>

<script>
export default {
  name: 'editLesWin',
  props: {
    winEditLes: Object
  },
  data() {
    return {
      types: [
        { value: "Лекция", text: "Лекция" },
        { value: "Практика", text: "Практика" },
        { value: "Лабораторная", text: "Лабораторная" },
        { value: "Другое", text: "Другое" }
      ],
      times: [
        { value: "8:20-9:50", text: "1: 8:20-9:50" },
        { value: "10:00-11:30", text: "2: 10:00-11:30" },
        { value: "11:45-13:15", text: "3: 11:45-13:15" },
        { value: "14:00-15:30", text: "4: 14:00-15:30" },
        { value: "15:45-17:15", text: "5: 15:45-17:15" },
        { value: "17:20-18:50", text: "6: 17:20-18:50" },
        { value: "18:55-20:25", text: "7: 18:55-20:25" }
      ]
    }
  },
  computed: {
    rec() {
      return this.winEditLes
    }
  },
  methods: {
    submitClick() {
      this.$emit('lesson-edit-submit', this.rec)
    }
  }
}
</script>
